<h1 mat-dialog-title>
  {{ title }}
</h1>

<div mat-dialog-content>
  <p [innerHTML]="message"></p>
</div>

<div mat-dialog-actions class="dialog-action">
  <button type="button" mat-button (click)="onDismiss()">{{ dismissLabel }}</button>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">{{ confirmLabel }}</button>
</div>
